import cleanseObject from "./cleanse-object";

export default cleanseObject;
